import { getResourceKind } from './resource-kind';
import { isSystemTag } from './system-tags';

export function linkedResourceEntityIds(
  refs: Array<{ sourceType: string; targetType: string; targetId: string }>,
  entityType: 'character' | 'location',
): Set<string> {
  const ids = new Set<string>();
  for (const ref of refs) {
    if (ref.sourceType === 'resource' && ref.targetType === entityType) {
      ids.add(ref.targetId);
    }
  }
  return ids;
}

export function optionsUsedOnResources<T extends { id: string }>(
  options: T[],
  usedIds: Set<string>,
  selectedIds: string[] = [],
): T[] {
  const selected = new Set(selectedIds);
  return options.filter((option) => usedIds.has(option.id) || selected.has(option.id));
}

export function resourceFilterOptions<T extends { id: string }>(params: {
  allOptions: T[];
  usedIds: Set<string>;
  selectedIds: string[];
  showAll: boolean;
}): T[] {
  if (params.showAll) {
    return params.allOptions;
  }
  return optionsUsedOnResources(params.allOptions, params.usedIds, params.selectedIds);
}

export function presentResourceKindIds(
  resources: Array<{
    url: string | null;
    s3Key: string | null;
    mimeType: string | null;
    tags?: string[] | null;
  }>,
  selectedKinds: string[] = [],
): Set<string> {
  const kinds = new Set(selectedKinds);
  for (const resource of resources) {
    kinds.add(getResourceKind(resource));
  }
  return kinds;
}

export function nonSystemTagsFromResources(
  resources: Array<{ tags?: string[] | null }>,
): string[] {
  return mergeTagNames(resources.flatMap((resource) => resource.tags ?? []));
}

export function mergeTagNames(...lists: string[][]): string[] {
  const tagSet = new Set<string>();
  for (const list of lists) {
    for (const tag of list) {
      const normalized = tag.trim().toLowerCase();
      if (normalized && !isSystemTag(normalized)) {
        tagSet.add(normalized);
      }
    }
  }
  return [...tagSet].sort((a, b) => a.localeCompare(b));
}
